export default __webpack_public_path__ + "3b8e2465df79bbf6f9a0059a5dd92d45.png";